import {
  ElementPropertyName,
  ElementPropertyType,
  IFactoryExpressionProperty,
} from '../../../models/element-property.model';

export const thermalTransmittanceProperty: IFactoryExpressionProperty = {
  name: ElementPropertyName.ThermalTransmittance,
  displayName: 'Thermal transmittance (u)',
  type: ElementPropertyType.Expression,
  unit: 'W/m²K',
  optional: true,
  fallbackCount: 0.12, // Common value for roof/walls according to perplexity
};
